import React, { ComponentType, useContext } from 'react';
import {
  Redirect, Route, RouteProps, Switch,
} from 'react-router-dom';
// import { useSelector } from 'react-redux';
import './i18n';
import PublicLayout from 'screens/PublicLayout';
import { LoadingContext } from 'context/Loading';
import { ModalErrorContext } from 'context/ModalError';
import NotificationModal from 'components/Modal/NotificationModal';
import { useTranslation } from 'react-i18next';
import { registerLocale } from 'react-datepicker';
import es from 'date-fns/locale/es';
import AppLoading from 'components/AppLoading';

registerLocale( 'es', es );

type CustomRouteProps = {
  isLoggedIn?: boolean,
  component: ComponentType<any>
} & RouteProps;

function PublicRoute( { component: Component, isLoggedIn, ...rest }: CustomRouteProps ) {
  return (
    <Route
      {...rest}
      render={( props ) => (
        isLoggedIn
          ? <Component {...props} />
          : <Redirect to={{ pathname: '/' }} />
      )}
    />
  );
}

function App() {
  const { t } = useTranslation();
  const { loading } = useContext( LoadingContext );
  const { description, showModal, closeErrorModal } = useContext( ModalErrorContext );
  return (
    <>
      <Switch>
        <PublicRoute path="/" component={PublicLayout} isLoggedIn />
      </Switch>
      {loading
      && (
        <AppLoading />
      )}
      <NotificationModal
        onClose={closeErrorModal}
        description={description}
        title={t( 'hasError' )}
        show={showModal}
        success={false}
      />
    </>
  );
}

export default App;
